import styled from '@emotion/styled'

export const Container = styled('div')`
  .map-container {
    height: 400px !important;
    border-radius: 8px;
  }
`

export const InputContainer = styled('div')`
  margin-top: 16px;
  .ant-input-affix-wrapper {
    width: 400px;
  }
`
